import { render, staticRenderFns } from "./selectPurchasingPlatform.vue?vue&type=template&id=4fa728e0&scoped=true"
import script from "./selectPurchasingPlatform.vue?vue&type=script&lang=js"
export * from "./selectPurchasingPlatform.vue?vue&type=script&lang=js"
import style0 from "./selectPurchasingPlatform.vue?vue&type=style&index=0&id=4fa728e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa728e0",
  null
  
)

export default component.exports